import React, { Component } from 'react';

export default class IntroText extends Component {


  render() {
    return (
      <section>
        <div className="intro-text p-4 pt-5">
          Hochmotivierte multimediale Gestalterin mit
          großer Leidenschaft für Musik, Film
          & Fotografie. Trotz großer Liebe zu
          vergangenen Zeiten (Musik & Design), hält sie
          ihr nostalgischer Hang nicht davon
          ab, Richtung Zukunft zu gehen und ihren
          kreativen Schüben auch im world wide web
          Ausdruck zu verleihen. Stresserprobt
          arbeitet sie allein und eigenverantwortlich,
          freut sich aber auch immer sehr über das
          Schaffen im Team.
        </div>
      </section>
    );
  }
}
